import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Label } from "reactstrap";
import { useHistory } from "react-router-dom";
import { C_Button } from "../../../../components/Common/CommonButton";
import { C_DatePicker, C_Select } from "../../../../CustomValidateForm";
import * as _cfunc from "../../../../components/Common/CommonFunction";
import { mode, pageId } from "../../../../routes/index"
import { MetaTags } from "react-meta-tags";
import C_Report from "../../../../components/Common/C_Report";
import { commonPageField, commonPageFieldSuccess, getpdfReportdataSuccess, postSelect_Field_for_dropdown } from "../../../../store/actions";
import { customAlert } from "../../../../CustomAlert/ConfirmDialog";
import * as report from '../../../../Reports/ReportIndex'
import { ExcelReportComponent } from "../../../../components/Common/ReportCommonFunc/ExcelDownloadWithCSS";
import { ItemSaleGoButton_API_Success } from "../../../../store/Report/ItemSaleReport/action";
import { allLabelWithZero } from "../../../../components/Common/CommonErrorMsg/HarderCodeData";
import { ItemSaleReport_GoBtn_API, PaymentModeDropdownAPIGET } from "../../../../helpers/backend_helper";



const PosSummarySale = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const currentDate_ymd = _cfunc.date_ymd_func();
    const isSCMParty = !_cfunc.loginUserIsFranchisesRole();
    const IsFranchises = _cfunc.loginUserIsFranchisesRole()
    const [headerFilters, setHeaderFilters] = useState('');
    const [userPageAccessState, setUserAccState] = useState('');

    const [PartyDropdown, setPartyDropdown] = useState(allLabelWithZero);
    const [paymentModeOptions, setPaymentModeOptions] = useState([{ value: "Select", label: "Select" }]);
    const [paymentModeLoading, setPaymentModeLoading] = useState(false);
    // ⭐ Payment Mode filter state
    const [PaymentMode, setPaymentMode] = useState({ value: 0, label: "All" });



    const reducers = useSelector(
        (state) => ({
            BtnLoading: state.PdfReportReducers.BtnLoading,

            pdfdata: state.PdfReportReducers.pdfdata,
            userAccess: state.Login.RoleAccessUpdateData,
            ItemSaleReportGobtn: state.ItemSaleReportReducer.ItemSaleReportGobtn,
            partyDropdownLoading: state.CommonPartyDropdownReducer.partyDropdownLoading,
            Party: state.CommonPartyDropdownReducer.commonPartyDropdownOption,
            goBtnLoading: state.ItemSaleReportReducer.goBtnLoading,
            pageField: state.CommonPageFieldReducer.pageField,
            SelectField: state.PartyMasterBulkUpdateReducer.SelectField, // ⭐ added
        })
    );


    const { userAccess, pageField, ItemSaleReportGobtn, partyDropdownLoading, Party, SelectField } = reducers

    const { fromdate = currentDate_ymd, todate = currentDate_ymd } = headerFilters;

    // Featch Modules List data  First Rendering
    const location = { ...history.location }
    const hasShowModal = props.hasOwnProperty(mode.editValue)

    const [localLoading, setLocalLoading] = useState(false);


    // userAccess useEffect
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;
        if (hasShowModal) {
            locationPath = props.masterPath;
        };
        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })
        if (userAcc) {
            setUserAccState(userAcc)
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])

    useEffect(() => {
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(pageId.POS_SALE_SUMMARY_REPORT));
        if (_cfunc.CommonPartyDropValue().value > 0) {
            setPartyDropdown(_cfunc.CommonPartyDropValue());
        }

        // ⭐ fetch payment mode dropdown options
        const jsonBody = {
            TypeID: 4,
            Company: _cfunc.loginCompanyID(),
        };
        dispatch(postSelect_Field_for_dropdown(jsonBody));

        return () => {
            dispatch(commonPageFieldSuccess(null));
        }
    }, [])

    useEffect(() => {

        try {
            if ((ItemSaleReportGobtn.Status === true) && (ItemSaleReportGobtn.StatusCode === 200)) {

                const Details = _cfunc.loginUserDetails()

                if (ItemSaleReportGobtn.BtnMode === "excel") {
                    const posData = (ItemSaleReportGobtn.Data || []).filter(
                        item => item.Identify === "POS"
                    );
                    ExcelReportComponent({
                        pageField,
                        excelTableData: posData,
                        excelFileName: "Periodic GRN Report"
                    })
                    dispatch(ItemSaleGoButton_API_Success([]));
                } else if (ItemSaleReportGobtn.BtnMode === "print" || ItemSaleReportGobtn.BtnMode === "Thermalprint") {
                    const posData = (ItemSaleReportGobtn.Data || []).filter(
                        item => item.Identify === "POS"
                    );
                    let config = { rowData: { Data: [] } }
                    config.rowData["ReportType"] = (ItemSaleReportGobtn.BtnMode === "print") ? report.POSSaleSummary : report.Sale_Summary_Thermal_Print_Report;
                    config.rowData["Status"] = ItemSaleReportGobtn.Status
                    config.rowData["StatusCode"] = ItemSaleReportGobtn.StatusCode
                    config.rowData["Data"] = posData
                    config.rowData["Data"]["GSTIN"] = isSCMParty ? PartyDropdown.GSTIN : Details.GSTIN
                    config.rowData["Data"]["SupplierName"] = isSCMParty ? PartyDropdown.label : Details.PartyName
                    config.rowData["Data"]["Date"] = `From  ${_cfunc.date_dmy_func(fromdate)}  To  ${_cfunc.date_dmy_func(todate)}`




                    dispatch(getpdfReportdataSuccess(config.rowData))
                    dispatch(ItemSaleGoButton_API_Success([]));
                }
            }
            else if ((ItemSaleReportGobtn.Status === true) && (ItemSaleReportGobtn.StatusCode === 204)) {
                customAlert({
                    Type: 3,
                    Message: ItemSaleReportGobtn.Message,
                })
                dispatch(ItemSaleGoButton_API_Success([]));
                return
            }
        }
        catch (e) { }

    }, [ItemSaleReportGobtn]);

    async function fetchPaymentModeOptions(partyId) {
        setPaymentModeLoading(true);
        try {
            const response = await PaymentModeDropdownAPIGET(partyId);
            if (response.Status === true) {
                const options = [
                    { value: 0, label: "All" },
                    ...(response.Data || []).map((pm) => ({
                        value: pm.id,
                        label: pm.Payment_Mode,
                    })),
                ];
                setPaymentModeOptions(options);
            } else {
                setPaymentModeOptions([{ value: 0, label: "All" }]);
            }
        } catch (error) {
            setPaymentModeOptions([{ value: 0, label: "All" }]);
            console.error("Payment Mode API Error:", error);
        } finally {
            setPaymentModeLoading(false);
        }
    }

    useEffect(() => {
        const partyId = _cfunc.loginPartyID() || PartyDropdown.value;
        if (partyId) {
            fetchPaymentModeOptions(partyId);
            setPaymentMode({ value: 0, label: "All" }); // reset on party change
        }
    }, [PartyDropdown]);

    const Party_Option = useMemo(() => {
        let options = [];

        options = Party.map((i) => ({
            value: i.id,
            label: i.Name,
            GSTIN: i.GSTIN,
        }));
        options.unshift(allLabelWithZero);
        return options;
    }, [Party]);





    async function excel_And_GoBtnHandler(e, btnMode) {
        setLocalLoading(btnMode); // Start spinner
        try {
            const jsonBody = JSON.stringify({
                FromDate: fromdate,
                ToDate: todate,
                PartyType: 0,
                Party: !isSCMParty ? _cfunc.loginPartyID() : PartyDropdown.value,
                Employee: _cfunc.loginEmployeeID(),
                CompanyID: _cfunc.loginCompanyID(),
                ItemID: "0",
                IsSummary: true,
                // ⭐ Payment Mode passed to payload for all buttons (Thermal Print / Print / Excel)
                PaymentMode: PaymentMode?.value ?? 0,
            });

            const response = await ItemSaleReport_GoBtn_API({ jsonBody });

            if (response.Status === true) {
                response["BtnMode"] = btnMode;
                dispatch(ItemSaleGoButton_API_Success(response));
            } else {
                customAlert({
                    Type: 4,
                    Message: response.Message || "Unexpected response from server.",
                }); setLocalLoading(false);
            }
        } catch (error) {
            customAlert({
                Type: 4,
                Message: "An error occurred while fetching the report. Please try again.",
            }); setLocalLoading(false);
            console.error("API Error:", error);
        } finally {
            setLocalLoading(false); // Stop spinner
        }
    }



    function fromdateOnchange(e, date) {
        let newObj = { ...headerFilters }
        newObj.fromdate = date
        setHeaderFilters(newObj)
    }

    function todateOnchange(e, date) {
        let newObj = { ...headerFilters }
        newObj.todate = date
        setHeaderFilters(newObj)
    }

    function PartyDrodownOnChange(e) {
        setPartyDropdown(e);
    }

    // ⭐ Payment Mode onChange handler
    function PaymentModeOnChange(e) {
        setPaymentMode(e);
    }


    return (
        <React.Fragment>
            <MetaTags>{_cfunc.metaTagLabel(userPageAccessState)}</MetaTags>
            <div className="page-content">
                <div className="px-2 py-2 c_card_filter text-black">
                    <div
                        className="d-flex flex-wrap align-items-end"
                        style={{ gap: "25px", rowGap: "10px" }}
                    >

                        {/* From Date */}
                        <div style={{ minWidth: "130px" }}>
                            <Label className="mb-1 d-block" style={{ fontSize: "13px" }}>From Date</Label>
                            <C_DatePicker
                                name='fromdate'
                                value={fromdate}
                                onChange={fromdateOnchange}
                            />
                        </div>

                        {/* To Date */}
                        <div style={{ minWidth: "130px" }}>
                            <Label className="mb-1 d-block" style={{ fontSize: "13px" }}>To Date</Label>
                            <C_DatePicker
                                nane='todate'
                                value={todate}
                                onChange={todateOnchange}
                            />
                        </div>

                        {/* Party (SCM only) */}
                        {_cfunc.isAdminDivisionRole() &&
                            <div style={{ minWidth: "170px", flex: "1 1 170px", maxWidth: "220px" }}>
                                <Label className="mb-1 d-block" style={{ fontSize: "13px" }}>Party</Label>
                                <C_Select
                                    name="Party"
                                    value={PartyDropdown}
                                    isSearchable={true}
                                    isDisabled={_cfunc.loginUserIsFranchisesRole()}
                                    isLoading={partyDropdownLoading}
                                    className="react-dropdown"
                                    classNamePrefix="dropdown"
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 3 })
                                    }}
                                    options={Party_Option}
                                    onChange={PartyDrodownOnChange}
                                />
                            </div>
                        }

                        {/* ⭐ Payment Mode */}
                        <div style={{ minWidth: "170px", flex: "1 1 170px", maxWidth: "220px" }}>
                            <Label className="mb-1 d-block" style={{ fontSize: "13px" }}>Payment Mode</Label>
                            <C_Select
                                name="PaymentMode"
                                value={PaymentMode}
                                isSearchable={true}
                                className="react-dropdown"
                                classNamePrefix="dropdown"
                                styles={{
                                    menu: provided => ({ ...provided, zIndex: 3 })
                                }}
                                options={paymentModeOptions}
                                onChange={PaymentModeOnChange}
                            />
                        </div>

                        {/* Buttons — pushed to the end, wrap onto their own line on small screens */}
                        <div
                            className="d-flex flex-wrap ms-auto"
                            style={{ gap: "8px" }}
                        >
                            <C_Button
                                type="button"
                                spinnerColor="white"
                                className="btn btn-success"
                                loading={localLoading === "Thermalprint"}
                                onClick={(e) => excel_And_GoBtnHandler(e, "Thermalprint")}
                            >
                                Thermal Print
                            </C_Button>
                            <C_Button
                                type="button"
                                spinnerColor="white"
                                className="btn btn-success"
                                loading={localLoading === "print"}
                                onClick={(e) => excel_And_GoBtnHandler(e, "print")}
                            >
                                Print
                            </C_Button>

                            <C_Button
                                type="button"
                                spinnerColor="white"
                                loading={localLoading === "excel"}
                                className="btn btn-primary"
                                onClick={(e) => excel_And_GoBtnHandler(e, "excel")}
                            >
                                Excel
                            </C_Button>
                        </div>
                    </div>
                </div>



            </div>
            <C_Report />
        </React.Fragment >
    )
}

export default PosSummarySale;